import React from "react";
import { HOME_FAQ } from "../../content/siteContent";

export const FaqAreaOne = () => {
  return (
    <section className="faq-area">
      <div className="faq-bg-shape"></div>

      <div className="faq-shape-wrap">
        <img src="images/home/line_bg.png" alt="" />
        <img src="/images/home/dots.png" alt="" />
      </div>

      <div className="container">
        <div className="row align-items-end justify-content-center">
          <div className="col-lg-6 col-md-9">
            <div className="faq-img-wrap">
              <img src="/images/home/team-consultation.webp" alt="Zawix Business Consultants team reviewing client documents" />
              <img src="/images/home/stats.jpg" alt="" data-parallax='{"y" : 100 }' />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="faq-content">
              <div className="section-title mb-30 tg-heading-subheading animation-style2">
                <span className="sub-title tg-element-title">
                  {HOME_FAQ.eyebrow}
                </span>
                <h2 className="title tg-element-title">
                  {HOME_FAQ.title}
                </h2>
              </div>
              <p>{HOME_FAQ.description}</p>

              <div className="accordion-wrap">
                <div className="accordion" id="accordionExample">
                  {HOME_FAQ.items.map((item, index) => {
                    const collapseId = `homeFaq${index}`;
                    return (
                      <div key={item.question} className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className={`accordion-button ${index ? "collapsed" : ""}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded={index === 0}
                            aria-controls={collapseId}
                          >
                            {item.question}
                          </button>
                        </h2>
                        <div
                          id={collapseId}
                          className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <p>{item.answer}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
